export default __webpack_public_path__ + "static/NBInternationalPro-Light-a89b87e8fa94bb44b5ba382cc72c49f6.otf";